export type GroupedOption = {
  value: string,
  label: string,
  options: ColoredOption[],
}

export type ColoredOption = {
  value: string,
  label: string,
  color: string,
}

export type NumberOption = {
  value: number,
  label: number,
}

export const options_report_kind = [
  {value: 1, label: "実績レポート"},
  {value: 2, label: "デモグラレポート"},
];

export const options_demographic_report_output_case_lebel = [
  {value: 1, label: "キャンペーン"},
  {value: 2, label: "広告グループ"},
];

export const options_demographic_report_extract_period_kind = [
  {value: 1, label: "当月"},
  {value: 2, label: "前月"},
  {value: 4, label: "過去7日間"},
  {value: 5, label: "カスタム"},
];

export const options_extract_timing_kind = [
  {value: 3, label: "即時"},
  {value: 1, label: "繰り返し"},
  {value: 2, label: "日時指定"},
];

export const options_extract_timing_kind_without_realtime = [
  {value: 1, label: "繰り返し"},
  {value: 2, label: "日時指定"},
];

export const options_extract_frequency_kind = [
  {value: 1, label: "毎週"},
  {value: 2, label: "毎月"},
];

export const options_extract_day = [
  {value: 1, label: '1'},
  {value: 2, label: '2'},
  {value: 3, label: '3'},
  {value: 4, label: '4'},
  {value: 5, label: '5'},
  {value: 6, label: '6'},
  {value: 7, label: '7'},
  {value: 8, label: '8'},
  {value: 9, label: '9'},
  {value: 10, label: '10'},
  {value: 11, label: '11'},
  {value: 12, label: '12'},
  {value: 13, label: '13'},
  {value: 14, label: '14'},
  {value: 15, label: '15'},
  {value: 16, label: '16'},
  {value: 17, label: '17'},
  {value: 18, label: '18'},
  {value: 19, label: '19'},
  {value: 20, label: '20'},
  {value: 21, label: '21'},
  {value: 22, label: '22'},
  {value: 23, label: '23'},
  {value: 24, label: '24'},
  {value: 25, label: '25'},
  {value: 26, label: '26'},
  {value: 27, label: '27'},
  {value: 28, label: '28'},
  {value: 29, label: '29'},
  {value: 30, label: '30'},
  {value: 31, label: '31'},
];

export const options_repeat_status = [
  {value: 1, label: "有効"},
  {value: 2, label: "停止中"},
];

export const options_edit_repeat_status = [
  {value: 1, label: "有効"},
  {value: 2, label: "停止"},
];

export const options_menu_kind = [
  {value: 1, label: "パフォーマンス広告", color: "#0052CC"},
  {value: 2, label: "メール広告", color: "#FF5630"},
];

export const options_menu_kind_report = [
  {value: 1, label: "パフォーマンス広告", color: "#0052CC"},
  {value: 2, label: "メール広告", color: "#FF5630"},
];

export const options_demographic_report_menu_kind = [
  {value: 2, label: "メール広告", color: "#FF5630"},
];

export const options_menu_campaign_kind = [
  {value: "1_1", label: "Performance Network"},
  {value: "1_2", label: "docomo connecting path DSP"},
  {value: "2_1", label: "メッセージS"},
  {value: "2_2", label: "リアルタイムメッセージS"},
];

export const options_select_all = [{
  value: "all",
  label: "すべて",
}];

export const options_download_kind = [
  {value: 1, label: "jpeg"},
  {value: 2, label: "png"},
  {value: 3, label: "csv"},
];

export const options_demographic_display_period_kind = [
  {value: 1, label: "直近1ヶ月"},
  {value: 2, label: "直近1週間"},
];

export const options_setpoint_columns = [
  {value: "trackingPointCvClickThrough", label: "ラストクリックCV"},
  {value: "trackingPointCvAssist", label: "アシストクリックCV"},
  {value: "trackingPointCvrClickThrough", label: "ラストクリックCVR"},
  {value: "trackingPointCpaClickThrough", label: "ラストクリックCPA"},
];

export const options_graph_campaign = [
  {value: 1,  label:"cost"},
  {value: 2,  label:"imp"},
  {value: 3,  label:"vimp"},
  {value: 4,  label:"click"},
  {value: 5,  label:"CTR"},
  {value: 6,  label:"vCTR"},
  {value: 7,  label:"平均CPC"},
  {value: 8,  label:"CPM"},
  {value: 9,  label:"CV(合計)"},
  {value: 10, label:"ラストクリックCV"},
  {value: 11, label:"アシストクリックCV"},
  {value: 12, label:"CVR(合計)"},
  {value: 13, label:"ラストクリックCVR"},
  {value: 14, label:"アシストクリックCVR(合計)"},
  {value: 15, label:"CPA(合計)"},
  {value: 16, label:"ラストクリックCPA"},
  {value: 17, label:"アシストクリックCPA(合計)"},
  {value: 18, label:"最適化ポイントCV"},
  {value: 19, label:"最適化ポイントCVR"},
  {value: 20, label:"最適化ポイントCPA"},
];

export const options_graph_adgroup = [
  {value: 1,  label:"cost"},
  {value: 2,  label:"imp"},
  {value: 4,  label:"click"},
  {value: 5,  label:"CTR"},
  {value: 7,  label:"平均CPC"},
  {value: 8,  label:"CPM"},
  {value: 9,  label:"CV(合計)"},
  {value: 10, label:"ラストクリックCV"},
  {value: 11, label:"アシストクリックCV"},
  {value: 12, label:"CVR(合計)"},
  {value: 13, label:"ラストクリックCVR"},
  {value: 14, label:"アシストクリックCVR(合計)"},
  {value: 15, label:"CPA(合計)"},
  {value: 16, label:"ラストクリックCPA"},
  {value: 17, label:"アシストクリックCPA(合計)"},
];

export const options_graph_zeus = [
  {value: 1,  label:"cost"},
  {value: 2,  label:"imp"},
  {value: 4,  label:"click"},
  {value: 5,  label:"CTR"},
  {value: 7,  label:"平均CPC"},
  {value: 8,  label:"CPM"},
  {value: 9,  label:"CV(合計)"},
  {value: 10, label:"ラストクリックCV"},
  {value: 11, label:"アシストクリックCV"},
  {value: 12, label:"CVR(合計)"},
  {value: 13, label:"ラストクリックCVR"},
  {value: 14, label:"アシストクリックCVR(合計)"},
  {value: 15, label:"CPA(合計)"},
  {value: 16, label:"ラストクリックCPA"},
  {value: 17, label:"アシストクリックCPA(合計)"},
  {value: 18, label:"最適化ポイントCV"},
  {value: 19, label:"最適化ポイントCVR"},
  {value: 20, label:"最適化ポイントCPA"},
];

export const options_demographic_graph_campaign = [
  {value: 2,  label:"cost"},
  {value: 3,  label:"imp"},
  {value: 4,  label:"vimp"},
  {value: 5,  label:"click"},
  {value: 6,  label:"CTR"},
  {value: 7,  label:"vCTR"},
  {value: 8,  label:"平均CPC"},
  {value: 9,  label:"CPM"},
  {value: 10,  label:"CV(合計)"},
  {value: 11, label:"ラストクリックCV"},
  {value: 12, label:"アシストクリックCV"},
  {value: 13, label:"CVR(合計)"},
  {value: 14, label:"ラストクリックCVR"},
  {value: 15, label:"アシストクリックCVR(合計)"},
  {value: 16, label:"CPA(合計)"},
  {value: 17, label:"ラストクリックCPA"},
  {value: 18, label:"アシストクリックCPA(合計)"},
];

export const options_demographic_graph_adgroup = [
  {value: 2,  label:"cost"},
  {value: 3,  label:"imp"},
  {value: 5,  label:"click"},
  {value: 6,  label:"CTR"},
  {value: 8,  label:"平均CPC"},
  {value: 9,  label:"CPM"},
  {value: 10,  label:"CV(合計)"},
  {value: 11, label:"ラストクリックCV"},
  {value: 12, label:"アシストクリックCV"},
  {value: 13, label:"CVR(合計)"},
  {value: 14, label:"ラストクリックCVR"},
  {value: 15, label:"アシストクリックCVR(合計)"},
  {value: 16, label:"CPA(合計)"},
  {value: 17, label:"ラストクリックCPA"},
  {value: 18, label:"アシストクリックCPA(合計)"},
];